'use strict';

exports.__esModule = true;
exports.SLIDE = exports.SPREAD = exports.BLINK = exports.animate = exports.Decorator = undefined;

var _HoC = require('./HoC');

var _HoC2 = _interopRequireDefault(_HoC);

var _Decorator = require('./Decorator');

var _Decorator2 = _interopRequireDefault(_Decorator);

var _modes = require('./modes');

require('../style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// The alias of decorator
var animate = _Decorator2['default'];

_HoC2['default'].Decorator = _Decorator2['default'];
_HoC2['default'].animate = animate;
_HoC2['default'].BLINK = _modes.BLINK;
_HoC2['default'].SPREAD = _modes.SPREAD;
_HoC2['default'].SLIDE = _modes.SLIDE;

exports['default'] = _HoC2['default'];
exports.Decorator = _Decorator2['default'];
exports.animate = animate;
exports.BLINK = _modes.BLINK;
exports.SPREAD = _modes.SPREAD;
exports.SLIDE = _modes.SLIDE;


//////////////////
// WEBPACK FOOTER
// ./~/react-hold-animation/lib/index.js
// module id = 192
// module chunks = 0